export default __webpack_public_path__ + "static/icon-nav-8eec02a1d1cadf0fa5a7a17f48e89305.png";